import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    PART_AND_VEHICLE_NON_COMPLIANT: {
        id: 'spareParts.problemCategory.option.partAndVehicleNonCompliant',
        defaultMessage: 'Part & Veh non compliant' // ok
    },
    WAY_OF_SELLING: {
        id: 'spareParts.problemCategory.option.wayOfSelling',
        defaultMessage: 'Way of selling' // ok
    },
    // REQUEST_JUSTIFIED_MTC_UPDATE: {
    //     id: 'spareParts.problemCategory.option.requestJustifiedMTCUpdate',
    //     defaultMessage: 'Request Justified MTC update'
    // },
    HISTO_FILE_ERROR_UPDATE: {
        id: 'spareParts.problemCategory.option.histoFileErrorUpdate',
        defaultMessage: 'Histo File update needed' // ok
    },
    ILLUSTRATION_UPDATE: {
        id: 'spareParts.problemCategory.option.illustrationUpdate',
        defaultMessage: 'Illustration update' // ok
    },
    // REQUEST_JUSTIFIED_SIGNEPA_UPDATE: {
    //     id: 'spareParts.problemCategory.option.requestJustifiedSignePAUpdate',
    //     defaultMessage: 'Request Justified SignePA update'
    // },
    // ASE_TEAM_TRANSFER: {
    //     id: 'spareParts.problemCategory.option.aseTeamTransfer',
    //     defaultMessage: 'ASe team transfer'
    // },
    // WAREHOUSE_STOCK_CHECK: {
    //     id: 'spareParts.problemCategory.option.warehouseStockCheck',
    //     defaultMessage: 'Warehouse stock check'
    // },
    REPAIR_ENGINEERING_IS_NOT_CONCERNED: {
        id: 'spareParts.problemCategory.option.repairEngineeringIsNotConcerned',
        defaultMessage: 'Repair engineering not concerned' // ok
    },
    PART_NUMBER_AVAILABLE_IN_NDIALOGYS: {
        id: 'spareParts.problemCategory.option.partNumberAvailableInNdialogys',
        defaultMessage: 'Part number available in documentation' // ok
    },
    PART_NUMBER_DEPLETED_WITHOUT_REPLACEMENT: {
        id: 'spareParts.problemCategory.option.partNumberDepletedWithoutReplacement',
        defaultMessage: 'Part number depleted without replacement' // ok
    },
    SERIAL_LIFE_SPECIFICATION_ERROR: {
        id: 'spareParts.problemCategory.option.serialLifeSpecificationError',
        defaultMessage: 'Serial life specification error' // ok
    },
    VALIDATED_REPLACEMENT: {
        id: 'spareParts.problemCategory.option.validatedReplacement',
        defaultMessage: 'Replacement validated' // pl
    },
    REFUSED_REPLACEMENT: {
        id: 'spareParts.problemCategory.option.refusedReplacement',
        defaultMessage: 'Replacement refused' // ok
    },
    ALTERNATIVE_OFFER: {
        id: 'spareParts.problemCategory.option.alternativeOffer',
        defaultMessage: 'Alternative offer for PVI or VOR' // ok
    },
    // CURRENT_REPLACEMENT: {
    //     id: 'spareParts.problemCategory.option.currentReplacement',
    //     defaultMessage: 'Current replacement'
    // },
    ASBOM_UPDATE_NEEDED: {
        id: 'spareParts.problemCategory.option.asbomUpdateNeeded',
        defaultMessage: 'ASBOM update needed' // ok
    },
    ASBOM_OK_STOCK_CHECK_NEEDED: {
        id: 'spareParts.problemCategory.option.asbomOkStockCheckNeeded',
        defaultMessage: 'ASBOM OK Stock check needed' // ok
    }
});

export default messages;
